import React from 'react'
import { useStyles } from './styles.js'

const Download = (props) => {
  const classes = useStyles()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16.314"
      height="19.033"
      viewBox="0 0 16.314 19.033"
      {...props}
    >
      <g transform="translate(-4.5 -2.25)">
        <path
          class="a"
          fill="#f37320"
          d="M20.345,11.087l-.958-.958L14.227,15.28V2.25H12.868V15.28L7.708,10.128l-.958.958,6.8,6.8Z"
          transform="translate(-0.891)"
        />
        <path
          class="a"
          fill="#f37320"
          d="M19.454,27v2.719H5.859V27H4.5v2.719a1.359,1.359,0,0,0,1.359,1.359H19.454a1.359,1.359,0,0,0,1.359-1.359V27Z"
          transform="translate(0 -9.796)"
        />
      </g>
    </svg>
  )
}
export default Download
